export const HERO = {
    default: {
        title: "Your Undetectable AI Interview Copilot",
        subtitle: "Real-time answers for behavioral & coding questions.",
        badges: ["Undetectable", "1-Second Answers", "Powered by Opus 4.8"]
    },
    assistant: {
        title: "Your Real-Time AI Call Assistant",
        subtitle: "Real-time answers for behavioral & technical questions.",
        badges: ["Screen-Aware", "1-Second Answers", "Powered by Opus 4.8"]
    }
};
